import dailyCase from 'public/assets/temp/Daily_Case.webp?url'
import dailyCaseBg from 'public/assets/temp/daily_case_bg.webp?url'
import dailyCaseShop from 'public/assets/temp/daily_case_shop.webp?url'
import psStore from 'public/assets/temp/Platforms-Logo-Color.webp?url'
import googlePlay from 'public/assets/temp/Platforms-Logo-Color-2.webp?url'
import appleStore from 'public/assets/temp/Platforms-Logo-Color-1.webp'
import vote from 'public/assets/temp/tasks/vote.svg'
import x from 'public/assets/temp/tasks/x.svg'
import telegram from 'public/assets/temp/tasks/telegram.svg'
import defaultTaskIcon from 'public/assets/temp/tasks/default_task_icon.svg'
import friends from 'public/assets/temp/tasks/friends.svg'
import share from 'public/assets/temp/tasks/share.svg'
import tradeStormTrade from 'public/assets/temp/tasks/tradeStormTrade.svg'
import tradeUpscale from 'public/assets/temp/tasks/tradeUpscale.svg'
import boinkersMoon from 'public/assets/temp/tasks/boinkersMoon.svg'
import boinkersSlot from 'public/assets/temp/tasks/boinkersSlot.svg'
import leaderboardFirst from 'public/assets/temp/leaderboard/1.webp'
import leaderboardSecond from 'public/assets/temp/leaderboard/2.webp'
import leaderboardThird from 'public/assets/temp/leaderboard/3.webp'
import tasksBg from 'public/assets/temp/tasks/tasks_bg.webp'
import star from 'public/assets/temp/star.svg'
import defaultLeadershipMember from 'public/assets/temp/leaderboard/defaultLeadershipMember.jpg'

export const tempAssetsExports = {
  dailyCase,
  dailyCaseBg,
  dailyCaseShop,
  psStore,
  googlePlay,
  appleStore,
  star,
  tasks: {
    vote,
    x,
    telegram,
    general: defaultTaskIcon,
    friends,
    ton: share,
    tradeStormTrade,
    tradeUpscale,
    boinkersMoon,
    boinkersSlot,
    tasksBg,
    updateProgress: telegram,
    share,
    defaultTaskIcon,
  },
  leaderboard: {
    leaderboardFirst,
    leaderboardSecond,
    leaderboardThird,
    defaultLeadershipMember,
  }
}
